export default {
  branding: {
    error: {
      badUrl: 'Bad font URL. Please try again',
      invalidUrl: 'Invalid URL. Please try again.'
    },
    bold: 'Bold',
    color1: 'Color 1',
    color1Percentage: 'Color 1 gradient percentage',
    color2: 'Color 2',
    color2Percentage: 'Color 2 gradient percentage',
    createTheme: 'Theme Editor',
    downloadTheme: 'Save theme',
    light: 'Light',
    linearGradient: 'Linear Gradient',
    load: 'Load',
    medium: 'Medium',
    regular: 'Regular',
    remove: 'Remove',
    rotation: 'Rotation',
    rotationText: 'Rotation text',
    solid: 'Solid',
    solidColor: 'Solid Color',
    toggle: 'Theme Editor',
    uploadTheme: 'Load theme'
  }
};
